const PERMISSION_KEY= "core:user_two_fa_credential";
const PAGE_URL = {
    USER_TWO_FA_CREDENTIAL_PAGE: "/admin/core/user-two-fa-credential"
}

export {PERMISSION_KEY, PAGE_URL}

